// extracted by mini-css-extract-plugin
module.exports = {"button":"uHOQp V16Wa _1R_Wx","title":"_1ZnBW"};